import { Pipe } from "@angular/core";

@Pipe({
    name: "naFilter",
    standalone: false
})
export class NAFilterPipe {
    transform(input: any): number | null {
        if ( input == null || input.toString() == '' ||isNaN(Number(input))) {
            return null;
        }
        return Number(input);
    }
}

@Pipe({
    name: "naUnfilter",
    standalone: false
})
export class NAUnfilterPipe {
    transform(input: any): string {
        if (input == null) {
            return  'N/A';
        }
        return input.toString();
    }
}